import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadWantedListFailed, loadWantedListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadWantedList(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/wanted-list`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data && data.data) {
      yield put(loadWantedListSuccessful(data.data));
      yield call(resolveActionPromise(action));
    } else {
      yield put(loadWantedListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadWantedListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
